import React from "react";
import Text from "../../../../../common-deprecated/styles/toyota/Text";
import { useCompareV2Selector } from "../../../redux/store";
import * as CompareEntryStyles from "../styles/CompareEntry";
import { getEcoSpecs } from "../../../utils/formatters/priceAndEcoSpecsFormatters";
import CompareEta from "../../common/highlight/content/CompareEta";
import Rating from "./content/Rating";
import { loadEtaValuesInCompare, hideReviewScoresInCompare } from "../../../utils/settings";
import { CompareV2Label } from "../../../utils/labels";
import Icon from "../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import Popover from "../../../../../common-deprecated/components/popover/aem/Popover";
import CompareTable from "../../common/CompareTable";

const HighlightedSpecs = (): JSX.Element => {
    const cars = useCompareV2Selector(({ newCarCompare }) => newCarCompare.grades);
    const specs = useCompareV2Selector(({ newCarCompare }) => newCarCompare.parsedSpecs);
    const compareV2Settings = useCompareV2Selector((state) => state.compareV2Settings);
    const commonSettings = useCompareV2Selector((state) => state.commonSettings);
    const showEta = loadEtaValuesInCompare(compareV2Settings);
    const hideReviews = hideReviewScoresInCompare(compareV2Settings, commonSettings);
    const ecoSpecs = getEcoSpecs(specs, compareV2Settings.labels);

    return (
        <>
            {ecoSpecs.map((spec) => (
                <CompareTable
                    key={spec.titles.join("-")}
                    items={spec.values}
                    columnChild={(value, index) => (
                        <CompareEntryStyles.Wrapper>
                            <CompareEntryStyles.Title>
                                {spec.titles[index] || spec.titles[0]}
                                {spec.tooltip && <Popover showOnClick content={spec.tooltip} useHTML />}
                            </CompareEntryStyles.Title>
                            <CompareEntryStyles.KeyValue>
                                <CompareEntryStyles.Value>
                                    {value === "" && <Icon variant="minus" />}
                                    {value}
                                </CompareEntryStyles.Value>
                                {value && spec.unit && (
                                    <CompareEntryStyles.Suffix>
                                        {typeof spec.unit !== "string" ? spec.unit[index] : spec.unit}
                                    </CompareEntryStyles.Suffix>
                                )}
                            </CompareEntryStyles.KeyValue>
                        </CompareEntryStyles.Wrapper>
                    )}
                />
            ))}

            {showEta && (
                <CompareTable
                    items={cars}
                    columnChild={(car) => (
                        <CompareEntryStyles.Wrapper>
                            <CompareEntryStyles.Value>
                                <Text pt={{ xs: 1, md: 0 }} display={{ xs: "block", md: "inline" }}>
                                    <CompareEta
                                        date={car.eta && car.eta.date}
                                        etaLoading={car.eta && car.eta.loading}
                                        error={!car.eta || !!car.eta.errorMessage}
                                    />
                                </Text>
                            </CompareEntryStyles.Value>
                        </CompareEntryStyles.Wrapper>
                    )}
                />
            )}

            {!hideReviews && (
                <CompareTable
                    items={cars}
                    columnChild={(car) =>
                        !!car.ownerRating && (
                            <CompareEntryStyles.Wrapper>
                                <CompareEntryStyles.Title>
                                    <CompareV2Label label="compareBodyOwnerReviews" />
                                </CompareEntryStyles.Title>
                                <CompareEntryStyles.KeyValue>
                                    <CompareEntryStyles.Value>
                                        <Rating score={car.ownerRating} />
                                    </CompareEntryStyles.Value>
                                </CompareEntryStyles.KeyValue>
                            </CompareEntryStyles.Wrapper>
                        )
                    }
                />
            )}
        </>
    );
};

export default HighlightedSpecs;
